import {
    // createManageActive,
    // createManageArchive,
    // createManageDelete, createManageExportCsv,
    createManageSelect, createPage, /*createRowActionView*/
} from "../../../../utils/page";
import i18n from "../../../../i18n";

import {
    // onClickActiveAll,
    // onClickArchiveAll,
    // onClickDeleteAll,
    // onClickView
} from "../../../../utils/form";

import { createLoading } from "../../../../utils/loading";
import { defineAsyncComponent, reactive } from "vue";
import { createColumnInput } from "../../../../components/table/c-table.logic";
import store from "../../../../store";
import { addModal } from "../../../../app.logic";
import lodash from "lodash";
import { modalStyleIFrame } from "../../../../utils/constant";
import { has } from "../../../../utils/menu-context";
import { flatWhereGroup } from "../../../../utils/search";

export const { isLoading, setIsLoading } = createLoading()

export const actionPrefix = 'resource/v1/transaction/certificateRequest'
export const routerPrefix = 'company-products'

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form })
// export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria })
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id })
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id })
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } })
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids })
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids })
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } })
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria })
/*export const callAllApproveCompanyProduct = ({ searchQuery }) => store.dispatch('resource/v1/transaction/company-products/searchAllByCodeAndNameTh', { searchQuery, where, refCompanyId })*/
export const callSearch = ({ criteria }) => store.dispatch('resource/v1/transaction/companyProduct/search', { criteria })

const CIFrame = defineAsyncComponent(() => import('../../../../components/iframe/CIFrame'))

export const onSearch = ({ page, isSet = true }) => {
    const where = page.where || []
    setIsLoading(true)
    window.onSearch?.({ page })
    return callSearch({ criteria: { ...page, data: [], where: [{ name: "isActive", type: "Boolean", operator: "=", value: true }, ...where]  } })
        .then(page => (isSet ? (state.page = { ...page }) : page))
        .finally(() => setIsLoading(false))
}

export const createWhereRole = ({ props }) => {
    const { menuContext } = props
    const whereGroup = []
    if (has({ menuContext, key: 'forCompany' })) {
        const userInfo = store.state.resource.auth.info?.user
        whereGroup.push([{ name: 'createBy', type: 'String', operator: '=', value: userInfo.username }])
    }
    if (has({ menuContext, key: 'forCompanyApprove' })) {
        whereGroup.push([{ name: 'refStatus.key', type: 'String', operator: '!=', value: 'Draft' }])
    }
    return [{ name: 'isTmp', type: 'Boolean', operator: '=', value: false }, ...flatWhereGroup({ where: whereGroup, logic: 'OR' })]
}

export const createColumns = () => {
    const columns = []
    // columns.push(createColumnInput({ title: () => i18n.global.t("model.companyProduct.refCompany"), dataIndex: "refCompany.nameTh", align: 'center' }))
    columns.push(createColumnInput({ title: () => i18n.global.t("model.product.code"), dataIndex: "refProduct.code", align: 'center' }))
    columns.push(createColumnInput({ title: () => i18n.global.t("model.product.nameTh"), dataIndex: "refProduct.nameTh", align: 'center' }))
    columns.push(createColumnInput({ title: () => i18n.global.t("model.product.nameEn"), dataIndex: "refProduct.nameEn", align: 'center'}))
    columns.push(createColumnInput({ title: () => i18n.global.t("model.product.remark"), dataIndex: "remark", align: 'center'}))
    return columns
}

export const initState = ({ props }) => {
    const menuContext = props.menuContext
    state.manages = [
        createManageSelect({
            menuContext,
            type: window.selectType,
            getCheckboxProps: ({ record }) => ({ disabled: record.isActive !== true || window.selectGetCheckboxPropDisabled?.({ record }) })
        }),
        // createManageActive({
        //     menuContext,
        //     onClick: ({ rowSelection }) => onClickActiveAll({ rowSelection, callActiveAll, state, onSearch, setIsLoading }),
        // }),
        // createManageArchive({
        //     menuContext,
        //     onClick: ({ rowSelection }) => onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch, setIsLoading }),
        // }),
        // createManageDelete({
        //     menuContext,
        //     onClick: ({ rowSelection }) => onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch, setIsLoading }),
        // }),
        // createManageExportCsv({ menuContext, callData: ({ page }) => onSearch({ props, page: { ...lodash.cloneDeep({ ...page, page: 0, size: 1000000 }) }, isSet: false }) }),
    ]
    state.manageExtras = []
    state.rowActions = [
        // createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
    ]
}

export const openModalList = ({ bind, onIframeMounted }) => {
    const options = addModal({
        bind: lodash.merge(modalStyleIFrame, bind),
        render: () => <CIFrame src={`${process.env.VUE_APP_PUBLIC_PATH}/app/company/company-products?isLayout=false&canSelect=true&cacheQuery=true`} onIframeMounted={({ refs }) => onIframeMounted({ options, refs })}></CIFrame>

    })
    return options
}

export const state = reactive({
    columns: createColumns(),
    page: createPage({ options: { select: ['*', 'refCompany.*', 'refStatus.*', 'refProduct.*', 'refProduct.refProductType.*'] } }),
    tableOptions: { search: { activeKey: 'Search' } },
})

